import React from "react";

const InfoCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.334 6.29077C12.334 9.60448 9.64769 12.2908 6.33398 12.2908C3.02028 12.2908 0.333984 9.60448 0.333984 6.29077C0.333984 2.97706 3.02028 0.290771 6.33398 0.290771C9.64769 0.290771 12.334 2.97706 12.334 6.29077ZM6.92536 4.12626C6.92536 4.45448 6.65928 4.72056 6.33105 4.72056C6.00283 4.72056 5.73675 4.45448 5.73675 4.12626C5.73675 3.79803 6.00283 3.53195 6.33105 3.53195C6.65928 3.53195 6.92536 3.79803 6.92536 4.12626ZM6.75795 5.79032C6.75795 5.55362 6.56607 5.36175 6.32938 5.36175C6.09269 5.36175 5.90081 5.55362 5.90081 5.79032V8.79032C5.90081 9.02701 6.09269 9.21889 6.32938 9.21889C6.56607 9.21889 6.75795 9.02701 6.75795 8.79032V5.79032Z"
      fill="currentColor"
    />
  </svg>
);

export default InfoCircleIcon;
